import React from 'react';
import { ArrowDown, ArrowUpRight } from 'lucide-react';

const Hero = () => {
  return (
      <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-[#080a0f] text-white">

        {/* Atmospheric background */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-40 -right-40 w-[700px] h-[700px] rounded-full bg-[#3157ff]/10 blur-[140px]" />
          <div className="absolute -bottom-60 -left-40 w-[600px] h-[600px] rounded-full bg-[#5b7cff]/8 blur-[140px]" />

          <div
              className="absolute inset-0 opacity-[0.08]"
              style={{
                backgroundImage:
                    'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
                backgroundSize: '80px 80px',
              }}
          />

          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#080a0f]" />
        </div>

        <div className="relative z-10 max-w-[1400px] w-full mx-auto px-8 py-28">

          <div className="max-w-[950px]">

            {/* Eyebrow */}
            <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] text-neutral-400 mb-8">
              <span className="w-8 h-px bg-neutral-500" />
              THE NEXT GENERATION OF WEARABLES
            </div>

            {/* Main message */}
            <h1 className="text-[56px] sm:text-[68px] lg:text-[82px] leading-[0.98] font-semibold tracking-[-0.045em] text-white">
    <span className="text-neutral-400">
        Your devices know your body.
    </span>
              <br />
              What if they could understand your mind?
            </h1>
            {/* Supporting explanation */}
            <p className="mt-9 max-w-[720px] text-[17px] sm:text-[18px] leading-[1.65] text-neutral-400">
              FroCort is building the intelligence layer for familiar
              head-worn devices — from earbuds and headphones to future
              wearable form factors. We combine brain and body signals
              with AI to build toward a better understanding of how
              you're doing.
            </p>

            {/* Actions */}
            <div className="mt-10 flex flex-wrap items-center gap-4">

              <a
                  href="#experience"
                  className="inline-flex items-center gap-2 rounded-full bg-white text-neutral-950 text-[14px] font-medium px-6 py-3.5 hover:bg-neutral-200 transition-colors"
              >
                Explore FroCort
                <ArrowDown size={16} />
              </a>

              <a
                  href="#device-makers"
                  className="inline-flex items-center gap-2 rounded-full border border-white/15 text-neutral-300 text-[14px] px-6 py-3.5 hover:bg-white/5 hover:text-white transition-colors"
              >
                For device makers
                <ArrowUpRight size={15} />
              </a>

            </div>

            {/* Positioning clarification */}
            <div className="mt-8 flex items-center gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-[#8ea5ff]" />

                <p className="text-[12px] tracking-[0.12em] uppercase text-neutral-500">
                    Familiar devices from the brands you love. Powered by FroCort sensing and intelligence...
                </p>
            </div>

          </div>

          {/* Bottom statement */}
          <div className="mt-20 pt-7 border-t border-white/10 grid grid-cols-1 sm:grid-cols-3 gap-4">

              <p className="text-[11px] tracking-[0.16em] uppercase text-neutral-500">
                  Brain + body signals
              </p>

              <p className="text-[11px] tracking-[0.16em] uppercase text-neutral-500 sm:text-center">
                  Cognitive understanding
              </p>

              <p className="text-[11px] tracking-[0.16em] uppercase text-neutral-500 sm:text-right">
                  Familiar wearable devices
              </p>

          </div>

        </div>
      </section>
  );
};

export default Hero;